import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { RadioButton } from "primereact/radiobutton";
import { PERCENT_MAX_VALUE_OPTIONS, PercentQuestionOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The two percent dials (ADR 0034 §2).
 *
 * The largest number bounds the base a question is asked about, not the
 * percentage - the percentages are a fixed set chosen so every answer divides
 * out whole (ADR 0034 §3), and they are not a setting for that reason.
 */
export function PercentSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleQuestionChange(value: PercentQuestionOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...settings, PercentQuestion: value });
    }

    function handleMaxValueChange(event) {
        setSettings({ ...settings, PercentMaxValue: Number(event.target.value) });
    }

    return (
        <div className="percentSettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={settings.PercentQuestion}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(PercentQuestionOptions), settings.Language)}
                    className="select regrouping"
                    aria-label={t('settings.questionType')}
                />
            </div>
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.largestNumberLabel')}</span>
            </div>
            <div className="radioButtons" role="radiogroup" aria-label={t('settings.largestNumberAria')}>
                {PERCENT_MAX_VALUE_OPTIONS.map((option) => (
                    <div key={option}>
                        <RadioButton
                            inputId={`percentMaxValue-${option}`}
                            value={option}
                            checked={settings.PercentMaxValue === option}
                            onChange={handleMaxValueChange}
                        />
                        <label htmlFor={`percentMaxValue-${option}`}>{option}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PercentSettings;
